module.exports = __webpack_public_path__ + "static/media/suttacentral.28cff0db.png";